// extracted by mini-css-extract-plugin
export default {"modal":"cQ-z","modalOverlay":"dQ-z","outfitHeading":"eQ-z"};